"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsCronExpression = void 0;
const class_validator_1 = require("class-validator");
const IsCronExpression = (validationOptions) => (0, class_validator_1.Matches)(/((((\d+,)+\d+|(\d+(\/|-)\d+)|\d+|\*) ?){5,7})/g, Object.assign({ message: 'cronSchedule must be a valid cron expression' }, validationOptions));
exports.IsCronExpression = IsCronExpression;
